module.exports = __webpack_public_path__ + "img/auto-dimension.175d6e1a.svg";